import { types, actions } from './requests'
export const GETRECIPE_TYPES = {
    ...types('GETRECIPE'),
}
export const GETRECIPE_ACTIONS = {
    ...actions('GETRECIPE'),
}